// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".draggable-item[data-v-10bb6ad0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:10px;width:100%}.handle[data-v-10bb6ad0]{cursor:-webkit-grab;cursor:grab;margin-left:10px}", ""]);
// Exports
module.exports = exports;
